document.addEventListener("DOMContentLoaded", () => {
  const menuButton = document.querySelector(".header_left");
  const menuText = document.querySelector(".menu_btn_text");
  const closeIcon = document.querySelector(".close_svg");
  const header = document.querySelector(".header");
  const headerRight = document.querySelector(".header_right");
  const headerCenter = document.querySelector(".header_center");
  const menuContainer = document.querySelector(".menu_container");

  const isIndexPage = window.location.pathname === "/";
  let isMenuOpen = false;

  //search container
  const searchContainer = document.querySelector(".search_container");
  const searchBtn = document.querySelector(".search_btn");
  const searchBorder = document.querySelector(".search_border");
  let isExpanded = false;

  const toggleBodyScroll = (disable) => {
    if (disable) {
      document.body.style.setProperty("overflow", "hidden", "important");
    } else {
      document.body.style.removeProperty("overflow");
    }
  };
  function preventScroll(e) {
    e.preventDefault();
  }

  const toggleMenu = (open) => {
    isMenuOpen = open;
    toggleBodyScroll(open);

    if (open) {
      header.classList.add("expanded");

      menuText.style.opacity = "0";
      headerRight.style.opacity = "0";

      setTimeout(() => {
        menuText.style.visibility = "hidden";
        headerRight.style.visibility = "hidden";
        closeIcon.style.visibility = "visible";
        if (isIndexPage) {
          headerCenter.style.visibility = "visible";
          headerCenter.style.opacity = "0";
          setTimeout(() => {
            headerCenter.style.opacity = "1";
          }, 50);
        }
        closeIcon.style.opacity = "0";

        setTimeout(() => {
          closeIcon.style.opacity = "1";
          if (isIndexPage) {
            headerCenter.style.opacity = "1";
          }
        }, 50);
      }, 150);
    } else {
      closeIcon.style.opacity = "0";

      // Reset nav-2 states
      const contentWrapper = document.querySelector(".nav_2_content_wrapper");
      const mainContainer = document.querySelector(".link_container");
      const menuLinks = document.querySelectorAll(".menu_nav_2 .menu_link");

      // Remove active states from menu links
      menuLinks.forEach((link) => link.classList.remove("active"));

      // Reset content wrapper
      contentWrapper.style.opacity = "0";
      setTimeout(() => {
        contentWrapper.style.display = "none";

        // Reset main container and search visibility
        mainContainer.style.visibility = "visible";
        searchContainer.style.visibility = "visible";
        mainContainer.style.opacity = "1";
        searchContainer.style.opacity = "1";

        // Hide all nav-2 content and image sections
        document.querySelectorAll(".nav_2_body").forEach((content) => {
          content.style.display = "none";
          content.style.opacity = "0";
        });
        document.querySelectorAll(".nav_2_image_wrapper").forEach((wrapper) => {
          wrapper.style.display = "none";
          wrapper.style.opacity = "0";
        });
      }, 150);

      // Continue with existing menu close code
      setTimeout(() => {
        closeIcon.style.visibility = "hidden";
        if (isIndexPage) {
          headerCenter.style.visibility = "hidden";
        }
        menuText.style.visibility = "visible";
        headerRight.style.visibility = "visible";
        menuText.style.opacity = "0";
        headerRight.style.opacity = "0";
        header.classList.remove("expanded");

        setTimeout(() => {
          menuText.style.opacity = "1";
          headerRight.style.opacity = "1";
        }, 50);
      }, 150);
    }
  };

  menuButton.addEventListener("click", () => {
    toggleMenu(!isMenuOpen);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      if (isExpanded) {
        searchBtn.style.opacity = "0";

        setTimeout(() => {
          // Remove input and placeholder
          while (searchBtn.firstChild) {
            searchBtn.removeChild(searchBtn.firstChild);
          }
          searchBorder.style.opacity = "0";

          setTimeout(() => {
            searchContainer.classList.remove("expanded");
            searchBtn.textContent = "SEARCH";
            searchBtn.style.opacity = "1";
            isExpanded = false;
          }, 300);
        }, 150);
      } else if (isMenuOpen) {
        toggleMenu(false);
      }
    }
  });

  // Search Container
  document.addEventListener("click", (event) => {
    if (isExpanded && !searchContainer.contains(event.target)) {
      searchBtn.style.opacity = "0";

      setTimeout(() => {
        // Remove input and placeholder
        while (searchBtn.firstChild) {
          searchBtn.removeChild(searchBtn.firstChild);
        }
        searchBorder.style.opacity = "0";

        setTimeout(() => {
          searchContainer.classList.remove("expanded");
          searchBtn.textContent = "SEARCH";
          searchBtn.style.opacity = "1";
          isExpanded = false;
        }, 300);
      }, 150);
    }
  });

  // Prevent click outside from triggering immediately
  searchContainer.addEventListener("click", (event) => {
    event.stopPropagation();

    if (!isExpanded) {
      searchBtn.style.opacity = "0";

      setTimeout(() => {
        searchContainer.classList.add("expanded");
        searchBorder.style.opacity = "1";

        setTimeout(() => {
          // Create input element
          const searchInput = document.createElement("input");
          searchInput.type = "text";
          searchInput.className = "search_input title";

          // Create placeholder text
          const placeholder = document.createElement("div");
          placeholder.className = "search_placeholder title";
          placeholder.textContent = "ENTER KEYWORD...";

          // Add elements
          searchBtn.textContent = "";
          searchBtn.appendChild(placeholder);
          searchBtn.appendChild(searchInput);
          searchBtn.style.opacity = "1";

          // Handle input changes
          searchInput.addEventListener("input", () => {
            placeholder.style.display = searchInput.value ? "none" : "block";
          });

          searchInput.addEventListener("keypress", (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const searchQuery = searchInput.value.trim();
              if (searchQuery) {
                // Close search UI
                searchBtn.style.opacity = "0";
                setTimeout(() => {
                  while (searchBtn.firstChild) {
                    searchBtn.removeChild(searchBtn.firstChild);
                  }
                  searchBorder.style.opacity = "0";
                  setTimeout(() => {
                    searchContainer.classList.remove("expanded");
                    searchBtn.textContent = "SEARCH";
                    searchBtn.style.opacity = "1";
                    isExpanded = false;

                    // Redirect to search results
                    window.location.href = `/search?type=product&q=${encodeURIComponent(
                      searchQuery
                    )}`;
                  }, 300);
                }, 150);
              }
            }
          });

          searchInput.focus();
        }, 300);
      }, 150);

      isExpanded = true;
    }
  });
});
